import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { MarqueeRibbon } from "./components/Marquee";
import { Intro } from "./components/Intro";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Projects } from "./components/Projects";
import { Booking } from "./components/Booking";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { PrivacyPolicy } from "./components/PrivacyPolicy";

function App() {
  const [privacyOpen, setPrivacyOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        e.preventDefault();
        lenis.scrollTo(a.getAttribute("href"), { offset: -64 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App noise-overlay bg-ink text-white" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <MarqueeRibbon />
          <Intro />
          <About />
          <Services />
          <MarqueeRibbon outline />
          <Projects />
          <Booking />
          <Contact />
        </main>
        <Footer onPrivacy={() => setPrivacyOpen(true)} />
        <CookieBanner onPrivacy={() => setPrivacyOpen(true)} />
        <PrivacyPolicy open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
